import { makeAutoObservable } from "mobx";
import { ProjectInterface } from "./interfaces";
import ProjectsApi from "./api";
import authUserStore from "../auth/store";


class Store {
    private projects: ProjectInterface[] = [];

    constructor() {
        makeAutoObservable(this);
        this.prefetchData();
    }

    get getProjects(): ProjectInterface[] {
        return this.projects;
    }

    setProjects(projects: ProjectInterface[] | undefined): void {
        this.projects = projects || [];
    }

    getProjectById(id: number): ProjectInterface | undefined {
        return this.projects.find(project => project.id === id);
    }

    prefetchData = () => {
        if (!authUserStore.isLogin) return;

        ProjectsApi.get_all().then((projects: ProjectInterface[]) => {
            this.setProjects(projects);
        });
    };
}


const projectStore = new Store();
export default projectStore;
